// A shirt's page (sections/main-product.liquid): the "Size guide" link by the
// sizes, and on a phone the Add to cart bar along the bottom
// (snippets/dotcom-buy-bar.liquid).
(function () {
  // "Size guide" opens that row of the details and brings it into view
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.dotcom-size-link');
    if (!link) return;
    var row = document.querySelector(link.getAttribute('href'));
    if (!row) return;
    event.preventDefault();
    row.open = true;
    var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    row.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
    // (from the keyboard, carry on from the row)
    if (!event.detail) row.querySelector('summary').focus({ preventScroll: true });
  });

  var phone = matchMedia('(max-width: 749px)');
  var html = document.documentElement;

  function startBar(bar) {
    var section = bar.dataset.section;
    var info = document.getElementById('ProductInfo-' + section);
    var real = document.getElementById('ProductSubmitButton-' + section);
    if (!info || !real) return;
    var pick = bar.querySelector('[data-pick]');
    var button = bar.querySelector('button');
    var away = false; // the real button is out of view

    // what's picked and what it costs, as the page shows them now (after a
    // colour change, a sell-out or the € / £ switch alike)
    function refresh() {
      var price = info.querySelector('#price-' + section + ' .price');
      var amount =
        price &&
        (price.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--last')
          : price.querySelector('.price__regular .price-item--regular'));
      var picks = [].map.call(
        info.querySelectorAll('variant-selects input:checked, variant-selects select'),
        function (el) {
          return el.value;
        }
      );
      if (amount) picks.push(amount.textContent.trim());
      pick.textContent = picks.join(' · ');
      button.disabled = real.disabled;
      button.textContent = (real.querySelector('span') || real).textContent.trim();
    }
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        refresh();
      });
    }).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'checked', 'class'] });

    function show() {
      var on = phone.matches && away;
      bar.classList.toggle('is-on', on);
      html.classList.toggle('dotcom-buybar-on', on);
      if (on) html.style.setProperty('--dotcom-buybar-height', bar.offsetHeight + 'px');
    }
    new IntersectionObserver(function (entries) {
      away = !entries[entries.length - 1].isIntersecting;
      show();
    }).observe(real);
    phone.addEventListener('change', show);

    button.addEventListener('click', function () {
      real.click();
    });
    refresh();
  }

  function start() {
    document.querySelectorAll('.dotcom-buybar').forEach(startBar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
